<header>
    <nav class="navbar navbar-light px-2">
        <div class="wrapper">
            <div class="keep-left">
                @if (!isLandingPage) {
                    <div class="show justify-content-start align-self-center mr-2">
                        <ul class="navbar-nav flex-grow">
                            <main-menu></main-menu>
                        </ul>
                    </div>

                    <a class="mini-eflow-link" matTooltip="Acessar a página inicial do E-Flow Admin" [routerLink]="[Enums.PagesPaths.Home]">
                        <img class="mini-eflow-logo" alt="E-Flow" src="/assets/img/logo_eflow_admin.svg" />
                    </a>
                } @else {
                    <a class="mini-eflow-link" matTooltip="E-Flow Admin">
                        <img class="mini-eflow-logo" alt="E-Flow" src="/assets/img/logo_eflow_admin.svg" />
                    </a>
                }
            </div>

            <div class="navbar-collapse collapse show">
                @if (!isLandingPage) {
                    <ul class="navbar-nav flex-grow">
                        <help-menu [_isHintModeOn]="$isHintModeOn()" (_hintModeChange)="hintModeChange($event)"></help-menu>
                        <user-menu></user-menu>
                    </ul>
                }

                @if ($showLogInButton()) {
                    <button type="button" class="btn btn-warning login" (click)="logIn()">Acessar</button>
                }
            </div>
        </div>
    </nav>
</header>

<div class="hint-mode-floater" [class.on]="$isHintModeOn()" #floaterRef>
    <span class="fa-stack"
          matTooltip="Modo Ajuda: clique para alternar entre ativo e inativo. Uma vez ativo, passe o mouse sobre uma área de interesse para acessar dicas e orientações"
          (click)="toggleHintMode()"
          (keyDown)="toggleHintMode()"
    >
        <i class="fas fa-circle fa-stack-2x"></i>
        @if (!$isHintModeOn()) {
            <i class="fas fa-question fa-stack-1x"></i>
        }
        <i class="fas fa-lightbulb fa-stack-1x"></i>
    </span>

    @if ($isHintModeOn()) {
        <span class="active-tag">ATIVO</span>

        <i class="show-all-hints fas"
           matTooltip="Exibir todas as dicas"
           [ngClass]="$showAllHints() ? 'fa-eye' : 'fa-eye-slash'"
           (click)="toggleShowAllHints()"
           (keyDown)="toggleShowAllHints()"
        ></i>
    }
</div>
